import React, {useState} from 'react';
import {backend} from "../const";
import {useNavigate} from "react-router-dom";

function AddressForm() {
  const navigate = useNavigate()
  const [notify7d, setNotify7d] = useState(false);
  const [notify3d, setNotify3d] = useState(false);
  const [notify1d, setNotify1d] = useState(false);
  const [terms, setTerms] = useState(false);
  const [city, setCity] = useState('Warszawa');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState("");

  const register = async () => {
    const body = JSON.stringify({
      "email": email,
      "city": city,
      "addressPointId": selectedAddress.addressPointId,
      "addressText": selectedAddress.fullName,
      "reminder7d": notify7d,
      "reminder3d": notify3d,
      "reminder1d": notify1d,
      "terms": terms
    })
    const request1 = new Request(`${backend}/register`, {
      method: "POST",
      body: body,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    const response = await fetch(request1).then((response) => {
      if (response.status === 400) {
        const json = response.json().then(value=>{
          setError(value.message)
          return;
        })
        return;
      }
      if (response.status === 200) {
        setError("")
        // Request finished. Do processing here.
        navigate("/zapisany");
      }
    }).catch(error => {
      setError(error)
    })

  }

  const checkAddress = (addressText) => {
    fetch( `${backend}/register/address?check=${encodeURI(addressText)}`, {
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((response) => {
        if (response.status > 299) {

        } else {
          return response.json()
        }
      })
      .then(data => {
        setSuggestions(data)
      })
      .catch((err) => {
        console.log(err.message)
      });
  };

  const handleAddressChange = async (e) => {
    const value = e.target.value;
    setAddress(value);
    if (value.length < 4) {
      setSuggestions([]);
      return
    }
    checkAddress(address)
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    if(isValid) register()
  };

  const checkValid = (t, n7, n3, n1) => {
    setIsValid(t && selectedAddress.addressPointId !== undefined && email !== ""
      && (n7 || n3 || n1))
  }

  const changeTerms = (e) => {
    setTerms(e.target.checked);
    checkValid(e.target.checked, notify7d, notify3d, notify1d)
  }

  const changeNotify =
    (n7, n3, n1) => {
      setNotify7d(n7)
      setNotify3d(n3)
      setNotify1d(n1)
      checkValid(terms,n7, n3, n1)
    }

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <form onSubmit={handleSubmit} className="space-y-6">
        {!isValid && (
            <div>Podaj email, adres, wybierz jakie powiadomienia chcesz otrzymać oraz zaakceptuj warunki</div>)}
        <div>
          <label
            htmlFor="city"
            className="block text-sm font-medium text-gray-700"
          >
            Miasto
          </label>
          <select
            id="city"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          >
            <option value="Warszawa">Warszawa</option>
          </select>
        </div>

        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              checkValid(terms, notify7d, notify3d, notify1d)
            }}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder="twoj@email.com"
          />
        </div>

        <div className="relative">
          <label
            htmlFor="address"
            className="block text-sm font-medium text-gray-700"
          >
            Adres
          </label>
          <input
            type="text"
            id="address"
            value={address}
            onChange={handleAddressChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder="Wpisz adres..."
          />
          {suggestions.length > 0 && (
            <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 shadow-lg">
              {suggestions.map((suggestion, index) => (
                <li
                  key={index}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    setAddress(suggestion.fullName);
                    setSelectedAddress(suggestion);
                    setSuggestions([]);
                  }}
                >
                  {suggestion.fullName}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div>Kiedy chcesz otrzymać powiadomienie?</div>
        <div><label>
          <input type={"checkbox"} checked={notify7d}
                 onChange={event => changeNotify(event.target.checked, notify3d, notify1d)}/> 7 dni wcześniej
        </label></div>
        <div><label>
          <input type={"checkbox"} value={notify3d}
                 onChange={event => changeNotify(notify7d, event.target.checked, notify1d)}/> 3
          dni wcześniej
        </label>
        </div>
        <div><label>
          <input type={"checkbox"} checked={notify1d}
                 onChange={event => changeNotify(notify7d, notify3d, event.target.checked)}/> dzień wcześniej
        </label>
        </div>
        <div><label><input type={"checkbox"} checked={terms} onChange={event => changeTerms(event)}/> Akceptuje <a
            target="_blank" href={"/warunki"}><span className={"terms"}>warunki</span></a> usługi
        </label>
        </div>

        {error !== "" && (<div className={"error"}>{error}</div>)}
        {isValid && (<button
          type="submit"
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Zapisz mnie!
        </button>)}
      </form>
    </div>
  );
}

export default AddressForm;
